<script>
let lineId = "coco-nusa"
// document.getElementById('').textContent = new Date().getFullYear();

window.addEventListener('DOMContentLoaded', () => {
    const currentYearPlaceholder = document.getElementById('currentYear');
    if (currentYearPlaceholder) {
      currentYearPlaceholder.textContent = new Date().getFullYear();
    }
  });
</script>
<!--====== FOOTER PART START ======-->

    <footer id="footer" class="footer-area">
        <div class="footer-widget pt-40 pb-130">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-8">
                        <div class="footer-logo mt-50">
                            <a href="#">
                                <img src="assets/images/logocnk.png" alt="Logo">
                            </a>
                            <ul class="footer-info">
                                <li>
                                    <div class="single-info">
                                        <div class="info-icon">
                                            <i class="lni-whatsapp"></i>
                                        </div>
                                        <div class="info-content">
                                            <p>+62 812-5634-464</p>
                                        </div>
                                    </div> <!-- single info -->
                                </li>
                                <li>
                                    <div class="single-info">
                                        <div class="info-icon">
                                            <i class="lni-line"></i>
                                        </div>
                                        <div class="info-content">
                                            <p>+62 812-5770-5052</p>
                                        </div>
                                    </div> <!-- single info -->
                                </li>
                                <li>
                                    <div class="single-info">
                                        <div class="info-icon">
                                            <i class="lni-whatsapp"></i>
                                        </div>
                                        <div class="info-content">
                                            <p>+62 812-5770-5052</p>
                                        </div>
                                    </div> <!-- single info -->
                                </li>
                                <li>
                                    <div class="single-info">
                                        <div class="info-icon">
                                            <i class="lni-envelope"></i>
                                        </div>
                                        <div class="info-content">
                                            <p>coconusakhatulistiwa@gmail.com</p>
                                        </div>
                                    </div> <!-- single info -->
                                </li>
                                <li>
                                    <div class="single-info">
                                        <div class="info-icon">
                                            <i class="lni-map"></i>
                                        </div>
                                        <div class="info-content">
                                            <p>Jl. Wan Sagaf No. 8, 78116
Pontianak, Kalimantan Barat, Indonesia
</p>
                                        </div>
                                    </div> <!-- single info -->
                                </li>
                            </ul>
                            <ul class="footer-social mt-20">
                                <li><a href="#"><i class="lni-facebook-filled"></i></a></li>
                                <li><a href="https://www.instagram.com/coco_nusa_khatulistiwa/" target="_blank"><i class="lni-instagram"></i></a></li>
                                <li><a href="https://wa.me/628125634464?text=Please%20I%20need%20more%20to%20know%20about%20PT%20Coco%20Nusa%20Khatulistiwa" target="blank"><i class="lni lni-whatsapp"></i></a></li>
                                <li><a href="http://line.me/ti/p/~{lineId}" target="blank"><i class="lni lni-line"></i></a></li>
                            </ul>
                        </div> <!-- footer logo -->
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6">
                        <div class="footer-link mt-45">
                            <div class="f-title">
                                <h4 class="title">Links</h4>
                            </div>
                            <ul class="mt-15">
                                <li><a href="#">About</a></li>
                                <li><a href="#">Commodity</a></li>
                                <li><a href="#">How to Order</a></li>
                                <li><a href="#">Team</a></li>
                            </ul>
                            <div class="navbar-btn mt-20 d-none d-sm-block">
                                <a class="main-btn" href="https://drive.google.com/file/d/1Y37sQsi0521ma-JOU4eA-cMLuD8UWcoE/view?usp=drive_link" target="blank"><i class="lni lni-download"></i>Download Catalog</a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-4 col-sm-6 mt-40">
                    <iframe style="border:0; width: 100%; height: 270px;" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.817707836805!2d109.32665731432492!3d-0.031747999976821685!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e1d58ff3c2f182b%3A0x54e1d7f9929ff500!2sJl.%20Wansagaf%20No.8%2C%20Sungai%20Bangkong%2C%20Kec.%20Pontianak%20Kota%2C%20Kota%20Pontianak%2C%20Kalimantan%20Barat%2078423!5e0!3m2!1sen!2sid!4v1645244164636!5m2!1sen!2sid" allowfullscreen="" ></iframe>
                    </div>
                </div> <!-- row -->
            </div> <!-- container -->
        </div> <!-- footer widget -->
        <div class="copyright-area">
            <div class="container text-center">
      <div class="copyright">
        &copy; Copyright 2022 - <span id="currentYear"></span> <strong><span>Coco Nusa Khatulistiwa</span></strong>. All Rights Reserved
      </div>
      
    </div>
        </div> <!-- copyright-area -->

    </footer>

    <!--====== FOOTER PART ENDS ======-->